import type { Variant } from '@amplitude/experiment-react-native-client';

const AMPLITUDE_SESSION_EXPOSURE_DEDUPE_PREFIX = 'amplitude-session:';

interface IGetExperimentAssignmentExposureKeyOptions {
  dedupeKey: string;
  variant: Variant;
}

/** Builds the per-session exposure dedupe key from an Amplitude session id. */
export const getAmplitudeSessionExposureDedupeKey = (
  sessionId?: string | null
): string | undefined =>
  sessionId ? `${AMPLITUDE_SESSION_EXPOSURE_DEDUPE_PREFIX}${sessionId}` : undefined;

/** Builds a session latch key that remains distinct for every rendered assignment identity. */
export const getExperimentAssignmentExposureKey = ({
  dedupeKey,
  variant,
}: IGetExperimentAssignmentExposureKeyOptions): string =>
  JSON.stringify([dedupeKey, variant.expKey, variant.key ?? variant.value, variant.value]);
